import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import "../css/styles.css";
import { Link, useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);

function Home() {
  const [totalprojeto, setTotalprojeto] = useState();
  const [valorprojeto, setValorprojeto] = useState();
  const [altaprioridade, setAltaprioridade] = useState();
  const [maiorvalorprojeto, setMaiorvalorprojeto] = useState();
  const [agricultura, setAgricultura] = useState(0);
  const [meioambiente, setMeioambiente] = useState(0);
  const [governo, setGoverno] = useState(0);
  const [obras, setObras] = useState(0);
  const [saeg, setSaeg] = useState(0);
  const [codesg, setCodesg] = useState(0);
  const [planejamento, setPlanejamento] = useState(0);
  const [saude, setSaude] = useState(0);
  const [educacao, setEducacao] = useState(0);
  const [seguranca, setSeguranca] = useState(0);
  const [esporte, setEsporte] = useState(0);
  const [cultura, setCultura] = useState(0);
  const [turismo, setTurismo] = useState(0);
  const [mulher, setMulher] = useState(0);
  const [defesacivil, setDefesaCivil] = useState(0);
  const [administracao, setAdministracao] = useState(0);

  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleAdminLogin = () => {
    navigate("/login");
  };

  useEffect(() => {
    const token = localStorage.getItem("Token");
    setIsLoggedIn(!!token);
    axios
      .get("/api/totalprojeto")
      .then((res) => setTotalprojeto(res.data[0].total))
      .catch(console.log);
    axios
      .get("/api/valorprojeto")
      .then((res) => setValorprojeto(res.data[0].valor))
      .catch(console.log);
    axios
      .get("/api/altaprioridade")
      .then((res) => setAltaprioridade(res.data[0].alta))
      .catch(console.log);
    axios
      .get("/api/maiorvalorprojeto")
      .then((res) => setMaiorvalorprojeto(res.data[0].maior))
      .catch(console.log);

    axios
      .get("/api/quantidade-por-secretaria")
      .then((res) => {
        const map = {};
        res.data.forEach(({ secretaria, total }) => {
          map[secretaria] = total;
        });
        setPlanejamento(
          map[
            "02.03 - Secretaria Municipal de Planejamento, Coordenação e Habitação"
          ] || 0
        );
        setAdministracao(
          map["02.05 - Secretaria Municipal da Administração"] || 0
        );
        setGoverno(
          map["02.15 - Secretaria Municipal de Governo e Gestão Estratégica"] ||
            0
        );
        setObras(
          map["02.07 - Secretaria Municipal de Obras e Serviços Municipais"] ||
            0
        );
        setMeioambiente(
          map["02.17 - Secretaria Municipal de Meio Ambiente"] || 0
        );
        setSaeg(map["SAEG"] || 0);
        setCodesg(map["CODESG"] || 0);
        setSaude(map["02.11 - Secretaria Municipal de Saúde"] || 0);
        setEducacao(map["02.09 - Secretaria Municipal da Educação"] || 0);
        setSeguranca(
          map[
            "02.08 - Secretaria Municipal de Segurança e Mobilidade Urbana"
          ] || 0
        );
        setEsporte(map["02.10 - Secretaria Municpal de Esportes"] || 0);
        setCultura(map["02.16 - Secretaria Municipal da Cultura"] || 0);
        setTurismo(map["02.11 - Secretaria Municipal de Turismo e Lazer"] || 0);
        setMulher(map["02.20 -Secretaria de Políticas para as Mulheres"] || 0);
        setDefesaCivil(map["Assessoria Especial de Defesa Civil"] || 0);
        setAgricultura(map["02.13 - Secretaria Municipal da Agricultura"] || 0);
      })
      .catch(console.log);
  }, []);

  return (
    <main className="main-container">
      <div className="containerdashboard">
        <div
          style={{
            position: "relative",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          <h5
            className="m-0"
            style={{
              fontSize: "1.75rem",
              fontWeight: "bold",
              color: "#2c3e50",
              borderBottom: "3px solid #3498db",
              paddingBottom: "10px",
              display: "inline-block",
            }}
          >
            ESTRATIFICAÇÃO DOS PROCESSOS POR SECRETARIA
          </h5>

          {!isLoggedIn && (
            <button
              onClick={handleAdminLogin}
              className="btn btn-primary"
              style={{
                position: "absolute",
                right: "20px",
                top: "50%",
                transform: "translateY(-50%)",
                padding: "10px 40px",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              LOGIN
            </button>
          )}
        </div>

        <div className="main-cards">
          <Link to="/folhapagamento">
            <div className="card">
              <div className="card-inner">
                <h5>Número de Processos</h5>
                <i
                  className="fas fa-project-diagram"
                  style={{ fontSize: "24px", color: "#3498db" }}
                ></i>
              </div>
              <hr />
              <div>
                <h5>Total: {totalprojeto || 0}</h5>
                <p className="text-muted" style={{ fontSize: "14px" }}>
                  Processos ativos no sistema
                </p>
              </div>
            </div>
          </Link>
          <div className="card">
            <div className="card-inner">
              <h5>Valor estimado dos processos</h5>
              <i
                className="fas fa-dollar-sign"
                style={{ fontSize: "24px", color: "#2ecc71" }}
              ></i>
            </div>
            <hr />
            <div>
              <h5>
                {valorprojeto
                  ? new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(valorprojeto)
                  : "R$ 0,00"}
              </h5>
              <p className="text-muted" style={{ fontSize: "14px" }}>
                Investimento total
              </p>
            </div>
          </div>

          <div className="card">
            <div className="card-inner">
              <h5>Total de Secretarias</h5>
              <i
                className="fas fa-star"
                style={{ fontSize: "24px", color: "#f1c40f" }}
              ></i>
            </div>
            <hr />
            <div>
              <h5>Total: {18}</h5>
              <p className="text-muted" style={{ fontSize: "14px" }}>
                Numeros de Secretarias
              </p>
            </div>
          </div>

          <div className="card">
            <div className="card-inner">
              <h5>Maior valor de um projeto</h5>
              <i
                className="fas fa-chart-line"
                style={{ fontSize: "24px", color: "#e74c3c" }}
              ></i>
            </div>
            <hr />
            <div>
              <h5>
                {maiorvalorprojeto
                  ? new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(maiorvalorprojeto)
                  : "R$ 0,00"}
              </h5>
              <p className="text-muted" style={{ fontSize: "14px" }}>
                Projeto de maior orçamento
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="containerdashboard">
        <div className="Gra" style={{ height: "470px" }}>
          <Bar
            data={{
              labels: [
                "Agricultura",
                "Obras",
                "Governo",
                "Meio Ambiente",
                "SAEG",
                "CODESG",
                "Planejamento",
                "Saúde",
                "Educação",
                "Segurança",
                "Turismo",
                "Esporte",
                "Cultura",
                "Mulher",
                "Defesa Civil",
                "Administração",
              ],
              datasets: [
                {
                  label: "Quantidade de processos por secretaria",
                  data: [
                    agricultura,
                    obras,
                    governo,
                    meioambiente,
                    saeg,
                    codesg,
                    planejamento,
                    saude,
                    educacao,
                    seguranca,
                    turismo,
                    esporte,
                    cultura,
                    mulher,
                    defesacivil,
                    administracao,
                  ],
                  backgroundColor: [
                    "rgba(52, 152, 219, 0.7)",
                    "rgba(231, 76, 60, 0.7)",
                    "rgba(46, 204, 113, 0.7)",
                    "rgba(155, 89, 182, 0.7)",
                    "rgba(241, 196, 15, 0.7)",
                    "rgba(230, 126, 34, 0.7)",
                    "rgba(52, 73, 94, 0.7)",
                    "rgba(26, 188, 156, 0.7)",
                    "rgba(41, 128, 185, 0.7)",
                    "rgba(192, 57, 43, 0.7)",
                    "rgba(39, 174, 96, 0.7)",
                    "rgba(142, 68, 173, 0.7)",
                    "rgba(243, 156, 18, 0.7)",
                    "rgba(211, 84, 0, 0.7)",
                    "rgba(44, 62, 80, 0.7)",
                    "rgba(22, 160, 133, 0.7)",
                  ],
                  borderColor: [
                    "rgba(52, 152, 219, 1)",
                    "rgba(231, 76, 60, 1)",
                    "rgba(46, 204, 113, 1)",
                    "rgba(155, 89, 182, 1)",
                    "rgba(241, 196, 15, 1)",
                    "rgba(230, 126, 34, 1)",
                    "rgba(52, 73, 94, 1)",
                    "rgba(26, 188, 156, 1)",
                    "rgba(41, 128, 185, 1)",
                    "rgba(192, 57, 43, 1)",
                    "rgba(39, 174, 96, 1)",
                    "rgba(142, 68, 173, 1)",
                    "rgba(243, 156, 18, 1)",
                    "rgba(211, 84, 0, 1)",
                    "rgba(44, 62, 80, 1)",
                    "rgba(22, 160, 133, 1)",
                  ],
                  borderWidth: 1,
                  borderRadius: 5,
                  barThickness: 30,
                  hoverBackgroundColor: [
                    "rgba(52, 152, 219, 0.9)",
                    "rgba(231, 76, 60, 0.9)",
                    "rgba(46, 204, 113, 0.9)",
                    "rgba(155, 89, 182, 0.9)",
                    "rgba(241, 196, 15, 0.9)",
                    "rgba(230, 126, 34, 0.9)",
                    "rgba(52, 73, 94, 0.9)",
                    "rgba(26, 188, 156, 0.9)",
                    "rgba(41, 128, 185, 0.9)",
                    "rgba(192, 57, 43, 0.9)",
                    "rgba(39, 174, 96, 0.9)",
                    "rgba(142, 68, 173, 0.9)",
                    "rgba(243, 156, 18, 0.9)",
                    "rgba(211, 84, 0, 0.9)",
                    "rgba(44, 62, 80, 0.9)",
                    "rgba(22, 160, 133, 0.9)",
                  ],
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: "top",
                  labels: {
                    font: {
                      size: 12,
                      family: "'Poppins', sans-serif",
                    },
                    padding: 10,
                    usePointStyle: true,
                    pointStyle: "circle",
                  },
                },
                title: {
                  display: true,
                  text: "Distribuição de Processos por Secretaria",
                  font: {
                    size: 20,
                    family: "'Poppins', sans-serif",
                    weight: "600",
                  },
                  padding: {
                    top: 10,
                    bottom: 30,
                  },
                  color: "#2c3e50",
                },
                tooltip: {
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  titleColor: "#2c3e50",
                  titleFont: {
                    size: 14,
                    family: "'Poppins', sans-serif",
                    weight: "600",
                  },
                  bodyColor: "#2c3e50",
                  bodyFont: {
                    size: 13,
                    family: "'Poppins', sans-serif",
                  },
                  padding: 12,
                  borderColor: "#e1e8ed",
                  borderWidth: 1,
                  displayColors: true,
                  boxWidth: 10,
                  boxHeight: 10,
                  usePointStyle: true,
                  callbacks: {
                    label: function (context) {
                      return `Processos: ${context.parsed.y}`;
                    },
                  },
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  grid: {
                    color: "rgba(0, 0, 0, 0.1)",
                    drawBorder: false,
                  },
                  ticks: {
                    font: {
                      size: 12,
                      family: "'Poppins', sans-serif",
                    },
                    color: "#2c3e50",
                    padding: 10,
                  },
                },
                x: {
                  grid: {
                    display: false,
                  },
                  ticks: {
                    font: {
                      size: 12,
                      family: "'Poppins', sans-serif",
                    },
                    color: "#2c3e50",
                    padding: 5,
                    maxRotation: 45,
                    minRotation: 45,
                  },
                },
              },
              animation: {
                duration: 2000,
                easing: "easeInOutQuart",
              },
              layout: {
                padding: {
                  left: 15,
                  right: 15,
                  top: 15,
                  bottom: 15,
                },
              },
            }}
            height={470}
          />
        </div>
      </div>
    </main>
  );
}

export default Home;
